import { buildCapabilityMatrix } from './capability-matrix.js';
/** Probe browser rendering APIs. Safe to call only in DOM environments. */
export function probeViewerCapabilities() {
    if (typeof document === 'undefined') {
        const matrix = buildCapabilityMatrix({ webgpu: false, webgl2: false });
        return { webgpu: false, webgl2: false, matrix, environmentOk: false };
    }
    const canvas = document.createElement('canvas');
    const webgl2 = Boolean(canvas.getContext('webgl2'));
    const webgpu = typeof navigator !== 'undefined' && 'gpu' in navigator;
    const matrix = buildCapabilityMatrix({ webgpu, webgl2 });
    return {
        webgpu,
        webgl2,
        matrix,
        environmentOk: matrix.flags.environmentMaps,
    };
}
//# sourceMappingURL=probe.js.map